import { render, staticRenderFns } from "./WCGardener.vue?vue&type=template&id=1c800968&"
import script from "./WCGardener.vue?vue&type=script&lang=js&"
export * from "./WCGardener.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports